import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../SiteSettingsContext';
import { isCustomJewelryLinkVisible } from './customJewelrySettings';

/**
 * Link to /custom-jewelry when bespoke design is enabled for the placement.
 * @param {'shop'|'nav'|'footer'|'gift_finder'} placement
 */
export default function CustomJewelryLink({ placement = 'shop', className, children, ...rest }) {
  const { settings } = useSiteSettings();

  if (!isCustomJewelryLinkVisible(settings?.store_copy, placement)) {
    return null;
  }

  const cfg = settings?.store_copy?.custom_jewelry || {};
  const label =
    children ??
    (placement === 'nav' || placement === 'footer' ? cfg.nav_label : cfg.shop_button_label) ??
    'Custom jewelry design';

  return (
    <Link to="/custom-jewelry" className={className} {...rest}>
      {label}
    </Link>
  );
}
